var angular = require('angular');
var _module = angular.module('benoit');
var $ = require('jquery');

require('./_styles.scss');
require('../../services/lr-touch');
require('../ng-repeat-finished');

_module.component('lrphotowall', {
    template: require('./index.html'),
    bindings: {
        images: '<',
        onSlideClick: '&'
    },
    controllerAs: 'lrpw',
    controller: [
        '$log',
        '$timeout',
        '$element',
        '$window',
        '$scope',
        '$lrTouchStart',
        '$lrTouchMove',
        '$lrTouchEnd',

        function lrphotowallCtrl($log, $timeout, $element, $window, $scope, $lrTouchStart, $lrTouchMove, $lrTouchEnd) {
            $log.debug('LR Photo Wall', $element);

            var _this = this;
            var mobileMaxWidth = 600;
            var ul = $element.find('ul');

            this.totalWidth = 0;
            this.slideLeft = 0;
            this.counter = 0;
            this.dragging = false;

            // Ctrl Functions
            this.next = function next() {
                var elemWidth = $element.find('li')[0].offsetWidth;
                if(window.innerWidth >= mobileMaxWidth) elemWidth /= 2;
                var windowWidth = window.innerWidth;
                var leftAmount = (Math.floor(windowWidth / elemWidth) * elemWidth);
                var move = leftAmount - _this.slideLeft;
                var totalWidth = calculateTotalWidth();
                var amount = Math.min(move, totalWidth);
                if(amount > (totalWidth - 20)) amount = totalWidth;

                if(amount !== totalWidth) _this.counter++;
                _this.totalWidth = totalWidth;
                _this.slideLeft = -amount;
            };

            this.previous = function previous() {
                var elemWidth = $element.find('li')[0].offsetWidth;
                if(window.innerWidth >= mobileMaxWidth) elemWidth /= 2;
                var windowWidth = window.innerWidth;
                var leftAmount = (Math.floor(windowWidth / elemWidth) * elemWidth);
                var move = leftAmount + _this.slideLeft;
                var totalWidth = calculateTotalWidth();
                var amount = Math.min(move, 0);
                if(amount > -20) amount = 0;

                if(amount !== 0) _this.counter++;
                _this.totalWidth = totalWidth;
                _this.slideLeft = amount;
            };

            this.slideClicked = function onSlideClick(image, $index) {
                _this.onSlideClick({ $image: image, $index: $index });
            };

            this.lisFinishedRendering = function lisFinishedRendering() {
                updateLIWidth();

                $($element.find('li')).get().forEach(function (li) {
                    var el = angular.element(li);

                    removeTouchListeners();
                    $lrTouchStart(el, onTouchStart);
                });

                $timeout(function () {_this.totalWidth = calculateTotalWidth(); }, 200);
            };

            // Functions
            function calculateTotalWidth() {
                if(window.innerWidth >= mobileMaxWidth) {
                    var windowWidth = window.innerWidth;
                    var lis = $.makeArray($element.find('li'));
                    var totalWidth = lis.slice(0, Math.ceil((lis.length + 1) / 2)).reduce(function (width, li) {
                        return width += li.offsetWidth;
                    }, 0);

                    return totalWidth - windowWidth;
                } else {
                    return window.innerWidth * (_this.images.length - 1);
                }
            }

            function onWindowResize(params) {
                _this.totalWidth = calculateTotalWidth();
                updateLIWidth();
                $scope.$digest();
            }

            function updateLIWidth() {
                if(window.innerWidth < mobileMaxWidth) {
                    $($element.find('li')).width(window.innerWidth);
                } else {
                    $($element.find('li')).css('width', '');
                }
            }

            var startPosition;
            var startX;
            var endX;
            var diffAmount = 0;
            var swipeDirection;
            var dragging = false;

            function onTouchStart(e, touchData) {
                if(window.innerWidth >= mobileMaxWidth) return;

                if(!dragging) startPosition = ul[0].getBoundingClientRect().left;
                _this.dragging = true;
                dragging = true;
                startX = touchData.pageX;
                endX = 0;

                $lrTouchMove(angular.element(e.target), onTouchMove);
                $lrTouchEnd(angular.element(e.target), onTouchEnd);

                $scope.$digest();
            }

            function onTouchMove(e, touchData) {
                e.preventDefault();

                var totalWidth = calculateTotalWidth();
                endX = touchData.pageX;
                diffAmount = startX - endX;
                _this.slideLeft = Math.max(Math.min(0, (startPosition + -diffAmount)), -totalWidth);

                $scope.$digest();
            }

            var toCancel;
            function onTouchEnd(e) {
                $scope.$applyAsync(function () {
                    var dragThreshold = 50;

                    _this.dragging = false;

                    if(toCancel) $timeout.cancel(toCancel);

                    toCancel = $timeout(function () {
                        if(Math.abs(diffAmount) > dragThreshold && endX !== 0) {
                            var elemWidth = $element.find('li')[0].offsetWidth;
                            var maxAmount = -(_this.images.length - 1) * elemWidth;
                            var amount;

                            if(diffAmount > 0) {
                                amount = (Math.floor(Math.abs(startPosition) / elemWidth) + 1) * elemWidth;
                                _this.slideLeft = Math.max(maxAmount, -amount);
                                _this.counter = -Math.max(maxAmount, -amount) / elemWidth;
                            } else {
                                amount = (Math.floor(Math.abs(startPosition) / elemWidth) - 1) * elemWidth;
                                _this.slideLeft = Math.min(0, -amount);
                                _this.counter = -Math.min(0, -amount) / elemWidth;
                            }

                            $timeout(function () {
                                dragging = false;
                            }, 300);
                        } else {
                            _this.slideLeft = startPosition;
                            dragging = false;
                        }
                    }, 50);

                    angular.element(e.target).off('touchmove');
                    angular.element(e.target).off('touchend');
                });
            }

            function removeTouchListeners() {
                $($element.find('li')).get().forEach(function (li) {
                    var el = angular.element(li);

                    el.off('touchstart', onTouchStart);
                    el.off('touchmove', onTouchMove);
                    el.off('touchend', onTouchEnd);
                });
            }

            // Listeners
            angular.element($window).on('resize', onWindowResize);

            $scope.$on('$destroy', function onDestroy() {
                angular.element($window).off('resize', onWindowResize);
                removeTouchListeners();
            });

            // Watchers

            $scope.$watch(function () {
                return (angular.isArray(_this.images))
                    ? _this.images.length
                    : 0;
            }, function (newVal, oldVal) {
                if(newVal !== oldVal) {
                    $timeout(_this.lisFinishedRendering, 100);
                }
            });
        }
    ]
});
